module.exports = __webpack_public_path__ + "img/album12_06.5ec05fd2.jpg";